module.exports = __webpack_public_path__ + "static/media/rni_cloud_logo.581b982e.png";